import {
    ASSIGN,
    CanUserCallback,
    CREATE,
    DELETE,
    IMPERSONATE,
    MODIFY,
    ROLE,
    USER,
    VIEW,
} from "src/context/FoodpilotContext";

export const resolveUserManagementPermissions = (canUser: CanUserCallback, isAdmin: () => boolean) => {
    const canViewUsers = canUser(VIEW, USER);
    const canCreateUsers = canUser(CREATE, USER);
    const canModifyUsers = canUser(MODIFY, USER);
    const canDeleteUsers = canUser(DELETE, USER);
    const canAssignUserRoles = canViewUsers && canUser(ASSIGN, ROLE);
    const canImpersonateUsers = isAdmin() || canUser(IMPERSONATE, USER);

    return {
        canViewUsers,
        canCreateUsers,
        canModifyUsers,
        canDeleteUsers,
        canAssignUserRoles,
        canImpersonateUsers,
        canManageUsers: canViewUsers || canCreateUsers || canModifyUsers || canDeleteUsers,
        canShowRowActions: canImpersonateUsers || canModifyUsers || canDeleteUsers || canAssignUserRoles,
    };
};
